<template>
  <div class="k-form-section" :class="sectionClasses" :style="{ '--section-span': columnSpan }">
    <fieldset v-if="legend">
      <legend :class="`${required ? 'form-required' : ''}`">{{ legend }}</legend>
      <slot></slot>
    </fieldset>
    <slot v-else></slot>
    <small v-if="hasError" class="section-error">
      <i class="fas fa-exclamation-circle" aria-hidden="true"></i> This section is required
    </small>
  </div>
</template>

<style scoped>
.k-form-section {
  grid-column: span var(--section-span, 1);
  padding: 16px;
  border-radius: 8px;
  border: 1px solid var(--kate-background-alpha);
  background-color: var(--kate-panel-alt);
}

.k-form-section.horizontal > fieldset,
.k-form-section.horizontal > div {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
}

.k-form-section legend {
  color: var(--kate-text-alt);
  font-size: 1.2em;
  font-weight: 600;
  margin-bottom: 12px;
}

.k-form-section legend.form-required::after {
  content: "*";
  color: var(--kate-type-danger);
  margin-left: 5px;
}

.section-error {
  color: var(--kate-type-danger);
  font-size: 0.9rem;
}

.k-form-section.has-error {
  border: 1px solid var(--kate-type-danger) !important;
}

.k-form-section.has-warning {
  border: 1px solid var(--kate-type-warning) !important;
}

/* Responsive adjustments for grid spans */
@media (max-width: 768px) {
  .k-form-section {
    grid-column: span 1;
  }

  /* Switch to vertical layout again at narrow screen widths */
  .k-form-section.horizontal > fieldset,
  .k-form-section.horizontal > div {
    flex-direction: column;
    align-items: flex-start;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .k-form-section {
    grid-column: span min(var(--section-span, 1), 2);
  }
}
</style>

<script>
export default {
  name: 'KFormSection',
  props: {
    legend: {
      type: String,
      default: '',
    },
    columnSpan: {
      type: Number,
      default: 1,
    },
    orientation: {
      type: String,
      default: 'vertical',
      validator: value => ['vertical', 'horizontal'].includes(value),
    },
    required: {
      type: Boolean,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    hasWarning: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    sectionClasses() {
      return {
        [this.orientation]: true,
        'has-error': this.hasError,
        'has-warning': this.hasWarning,
      };
    },
  },
};
</script>
